import { configs } from "../config/config";


export const addKey =  function (arr) {
    let defaultKey = 'id';
    if(arr.length === 0){
        return [];
    }
    for (var i = 0; i < arr.length; i++){
        if(arr[i].hasOwnProperty('key')){
            continue ;
        }else{
            if(arr[i].hasOwnProperty(defaultKey)){
                arr[i].key = arr[i].id;
            }else{
                arr[i].key = i;
            }
        }
    }
    return arr;
}

export const queryString = () => {
    let _queryString = {};
    const _query = window.location.search.substr(1);
    const _vars = _query.split('&');
    _vars.forEach((v, i) => {
        const _pair = v.split('=');
        if (!_queryString.hasOwnProperty(_pair[0])) {
            _queryString[_pair[0]] = decodeURIComponent(_pair[1]);
        } else if (typeof _queryString[_pair[0]] === 'string') {
            const _arr = [ _queryString[_pair[0]], decodeURIComponent(_pair[1])];
            _queryString[_pair[0]] = _arr;
        } else {
            _queryString[_pair[0]].push(decodeURIComponent(_pair[1]));
        }
    });
    return _queryString;
};


export const BreadCrumb = function(pathname){
    const breads = {
        first:"",
        second:""
    }
    // pathname like /user/index[]
   let  arr = pathname.substr(1).split("/");
   if(arr.length === 2 ){
        breads.first = arr[0]  
        breads.second = arr[1]

   }else if (arr.length === 1){
    breads.first = arr[0]  
   }
    return breads

}

export const getExpire = (ttl = null) => {
    let now = Date.parse(new Date());
    ttl = ttl ? ttl : configs.cache.expire;
    return now/1000+ ttl;
}


export const clearSearchData=(data)=>{
    for(var i = 0; i < data.length; i++){
        let installment = []
        if(data[i].installment_1 && data[i].installment_1 !== ""){
           installment.push({"Installment":data[i].installment_1})
        }
        if(data[i].installment_2 && data[i].installment_2 !== ""){
           installment.push({"Installment":data[i].installment_2})
        }
        if(data[i].installment_3 && data[i].installment_3 !== ""){
         installment.push({"Installment":data[i].installment_3})
        }
        if(data[i].installment_4 && data[i].installment_4 !== ""){
            installment.push({"Installment":data[i].installment_4})
         }
         if(data[i].installment_5  && data[i].installment_5 !== ""){
          installment.push({"Installment":data[i].installment_5})
         }
         if(data[i].installment_6 && data[i].installment_6 !== ""){
            installment.push({"Installment":data[i].installment_6})
         }
         if(data[i].installment_7 && data[i].installment_7 !== ""){
          installment.push({"Installment":data[i].installment_7})
         }
         if(data[i].installment_8 && data[i].installment_8 !== ""){
            installment.push({"Installment":data[i].installment_8})
         }
         if(data[i].installment_9 && data[i].installment_9 !== ""){
          installment.push({"Installment":data[i].installment_9})
         }
         if(data[i].installment_10 && data[i].installment_10 !== ""){
            installment.push({"Installment":data[i].installment_10})
         }
         if(data[i].installment_11 && data[i].installment_11 !== ""){
          installment.push({"Installment":data[i].installment_11})
         }
         if(data[i].installment_12 && data[i].installment_12 !== ""){
          installment.push({"Installment":data[i].installment_12})
         }

        data[i].installment = installment
    }
    return data
}

export const checkDfpState=(data)=>{
    if(!data.hasOwnProperty('actual_dev_stat') ||
     data.actual_dev_stat.state <= 3    ||
     data.actual_dev_stat.next_pay_dl <= 0 || data.actual_dev_stat.next_reminder <= 0
    ) {
        return false;
    }
    return true
}

export function formatDateString(dateString) {
    // 将字符串转换为 Date 对象
    const date = new Date(dateString);

    // 获取月份和日期
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1
    const day = String(date.getDate()).padStart(2, '0');

    // 返回格式化的字符串
    return `${month}-${day}`;
}

export function  truncateText (text, length)  {
    return text.length > length ? `${text.substring(0, length)}...` : text;
};

